// Colunistas.jsx
import React, { useRef } from "react";
import "./colunistas.css";
import { useNavigate } from "react-router-dom";

function Colunistas({ colunistas = [] }) {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  // drag-to-scroll handlers
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  function onMouseDown(e) {
    isDown.current = true;
    wrapperRef.current.classList.add("active-drag");
    startX.current = e.pageX - wrapperRef.current.offsetLeft;
    scrollLeft.current = wrapperRef.current.scrollLeft;
  }

  function onMouseLeave() {
    isDown.current = false;
    wrapperRef.current?.classList.remove("active-drag");
  }

  function onMouseUp() {
    isDown.current = false;
    wrapperRef.current?.classList.remove("active-drag");
  }

  function onMouseMove(e) {
    if (!isDown.current) return;
    e.preventDefault();
    const x = e.pageX - wrapperRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5; // velocidade
    wrapperRef.current.scrollLeft = scrollLeft.current - walk;
  }

  // touch equivalents for mobile
  function onTouchStart(e) {
    isDown.current = true;
    startX.current = e.touches[0].pageX - wrapperRef.current.offsetLeft;
    scrollLeft.current = wrapperRef.current.scrollLeft;
  }

  function onTouchMove(e) {
    if (!isDown.current) return;
    const x = e.touches[0].pageX - wrapperRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.5;
    wrapperRef.current.scrollLeft = scrollLeft.current - walk;
  }

  function onTouchEnd() {
    isDown.current = false;
  }

  return (
    <div
      className="colunista-wrapper"
      ref={wrapperRef}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="container-colunistas">
        {colunistas && colunistas.length > 0 ? (
          colunistas.map((c) => (
            <div
              key={c.id_colunista}
              className="colunista-card"
              onClick={() => navigate(`/colunistas/${c.id_colunista}/posts`)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(`/colunistas/${c.id_colunista}/posts`);
              }}
            >
              <img src={c.foto} alt={c.nome} className="colunista-foto" />
              <p className="colunista-nome">{c.nome}</p>
            </div>
          ))
        ) : (
          <p style={{ padding: "1rem" }}>Nenhum colunista encontrado.</p>
        )}
      </div>
    </div>
  );
}

export default Colunistas;